export const SAVE_ALL_REVIEW_CRITERIAS = 'SAVE_ALL_REVIEW_CRITERIAS'
